"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPersistentMemoryMsg = exports.SetPersistentMemoryMsg = void 0;
const router_1 = require("@keplr-wallet/router");
const constants_1 = require("./constants");
class SetPersistentMemoryMsg extends router_1.Message {
    constructor(data) {
        super();
        this.data = data;
    }
    static type() {
        return "set-persistent-memory";
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    validateBasic() { }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return SetPersistentMemoryMsg.type();
    }
}
exports.SetPersistentMemoryMsg = SetPersistentMemoryMsg;
class GetPersistentMemoryMsg extends router_1.Message {
    static type() {
        return "get-persistent-memory";
    }
    constructor() {
        super();
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    validateBasic() { }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return GetPersistentMemoryMsg.type();
    }
}
exports.GetPersistentMemoryMsg = GetPersistentMemoryMsg;
//# sourceMappingURL=messages.js.map